/** API client for the GIS fed-by check (spec 2026-09-02 section 6 Phase 4.4).
 *  The per-feeder counts ride on the data-quality rollup; this module is the
 *  paged worklist. Auth header is attached automatically by the shared `get`
 *  helper. */

import { get } from './client.ts'
import type { FedByFindingPage } from '../types/fedBy.ts'

export interface FedByFindingsParams {
  feeder_id?: number
  /** Omit for the MISMATCH set (off_chain + other_feeder). */
  classification?: string
  skip?: number
  limit?: number
}

export function getFedByFindings(
  params: FedByFindingsParams = {},
): Promise<FedByFindingPage> {
  const qs = new URLSearchParams()
  if (params.feeder_id != null) qs.set('feeder_id', String(params.feeder_id))
  if (params.classification) qs.set('classification', params.classification)
  if (params.skip != null) qs.set('skip', String(params.skip))
  if (params.limit != null) qs.set('limit', String(params.limit))
  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return get<FedByFindingPage>(`/engineering/fed-by-findings${suffix}`)
}
